<div class="loader-container">
  <div class="background-gradient"></div>
  <div class="pulse-wrapper">
    <div class="pulse">
      <div class="pulse-line"></div>
      <svg class="pulse-heartbeat" viewBox="0 0 240 120" xmlns="http://www.w3.org/2000/svg">
        <path
          class="heartbeat-path"
          d="M 10 60 L 50 60 L 55 45 L 60 60 L 70 60 L 75 75 L 85 25 L 95 80 L 100 60 L 110 60 L 115 55 L 120 60 L 230 60"
          fill="none"
          stroke="#ffffff"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    </div>
  </div>
</div>
